<template>
  <div class="page">
    <div class="m-bg-cover"></div>
    <div class="m-info-box">
      <div class="m-info-tit"><img src="@/assets/img/home/bcInfo.png" alt=""><span>个人信息</span></div>
      <div class="m-nav"><span>姓名</span><p>{{userInfoVO.username}}</p></div>
      <div class="m-nav"><span>证件号码</span><p>{{userInfoVO.idCardNumb}}</p></div>
      <div v-if="userInfoVO.admissionNumb" class="m-nav"><span>准考证号</span><p>{{userInfoVO.admissionNumb}}</p></div>
      <div class="m-nav"><span>考试</span><p>{{userInfoVO.examName}}</p></div>
    </div>
    <div class="m-info-box">
      <div class="m-bast">
        <div><img src="@/assets/img/home/myInfo.png" alt=""><span>考试成绩</span></div>
      </div>
      <div class="m-tab-box">
        <p class="m-tab">考试科目</p>
        <p class="m-tab">考试结果</p>
        <p class="m-tab">操作</p>
      </div>
      <div class="m-nav-box" v-for="(item,index) in userInfoVO.subScoreVOList" :key="index">
        <p class="m-tab">{{item.subName}}</p>
        <div class="m-tab">
          <p style="color: #1D232D" v-if="item.scoreStatus===null">暂无结果</p>
          <p v-else-if="item.scoreStatus=='合格'">{{item.scoreStatus}}</p>
          <p style="color: red" v-else-if="item.scoreStatus=='不合格'">{{item.scoreStatus}}</p>
          <p style="color: #1D232D" v-else="">{{item.scoreStatus}}</p>
        </div>
        <div class="m-tab m-height">
          <div v-if="item.scoreStatus=='不合格'&&item.scoreReviewStatus==-1||item.scoreReviewStatus===null" class="m-select" @click="goApply(item)">申请成绩复核</div>
          <div v-if="item.scoreStatus=='不合格'&&item.scoreReviewStatus==1" class="m-select-nav">已申请</div>
          <div v-if="item.scoreStatus=='不合格'&&item.scoreReviewStatus==0&&item.scoreReviewStatus!==null" class="m-select-nav m-select-nav1">已申请</div>
        </div>
      </div>
    </div>
    <van-button block class="x-btn-log m-btn-next" @click="goBack()">返回</van-button>
  </div>
</template>

<script>
  export default {
    components: {},
    data () {
      return {
        userInfoVO: {},
      }
    },
    created () {
      if(this.$route.query.id){
        this.getScore()
      }  
    },
    methods: {
      getScore(){
        if(!this.$route.query.id){
          this.utils.toastNone('缺少参数！')
          return
        }
        this.http.postRequest({
          url:`app/exam/showUserScoreList/${this.$route.query.id}`,
          msg:{},
          success:(res)=>{
            this.userInfoVO = res.data
          }
        })
      },
      goApply(i){
        if(!(i.id)){
          this.utils.toastNone('缺少ID！')
          return
        }
        this.http.postRequest({
          url: `app/exam/submitScoreReview/${i.id}`,
          msg: {},
          success: (res) => {
            this.getScore()
            if(res.msg){
              this.utils.toastNone(res.msg||res.code)
            }

          },
        },true)
      },
      goBack(){
        this.$router.go(-1)
      }
    },
    mounted () {

    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
.page {
  background: #F4F6F9;
  padding: 0 12px 90px 12px;
  .m-bg-cover{
    position: absolute;
    left: 0;
    right: 0;
    height: 180px;
    background: linear-gradient(360deg, #F4F6F9 0%, #2B6CF9 28% ,#2B6CF9 100%);
    z-index: -1;
  }
  .m-info-box{
    background: #ffffff;
    border-radius: 4px;
    padding: 15px 12px 12px 12px;
    margin-top: 18px;
    .m-info-tit{
      display: flex;
      align-items: center;
      padding-bottom: 15px;
      >img{
        width: 16px;
        height: 16px;
      }
      >span{
        color: #2B6CF9;
        font-weight: bold;
        margin-left: 3px;
      }
    }
    .m-bast{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 15px;
      >div{
        display: flex;
        align-items: center;
        >img{
          width: 16px;
          height: 16px;
        }
        >span{
          color: #2B6CF9;
          font-weight: bold;
          margin-left: 3px;
        }
      }
      .m-btn{
        height: 27px;
        line-height: 27px;
        color: #2B6CF9;
        border:1Px solid #2B6CF9;
      }
    }
    .m-nav{
      padding-bottom: 20px;
      display: flex;
      >span{
        display: inline-block;
        width: 90px;
        color: #8D8F93;
      }
      >p{
        flex: 1;
        text-align: right;
      }
      .m-pic{
        flex: 1;
        text-align: right;
        >img{
          width: 80px;
          height: 80px;
          object-fit: contain;
        }
      }
    }
  }
  .m-tab-box{
    padding: 0 10px;
    height: 35px;
    display: flex;
    align-items: center;
    gap:10px;
    background: #F9F9F9;
    border-radius: 4px 4px 4px 4px;
    .m-tab{
      color: #8D8F93;
    }
    .m-tab:nth-child(1){
      width: 100%;
      text-align: center;
    }
    .m-tab:nth-child(2){
      width: 100%;
      text-align: center;
    }
    .m-tab:nth-child(3){
      width: 100%;
      text-align: center;
    }
  }
  .m-nav-box{
    padding: 15px 10px 0 15px;
    display: flex;
    align-items: center;
    gap:10px;
    .m-tab{
      color: #1D232D;
      .m-select {
        width: 90px;
        height: 32px;
        background: #F2F6FF;
        border-radius: 4px;
        font-size: 13px;
        font-weight: 400;
        color: #2B6CF9;
        line-height: 32px;
        text-align: center;
      }
      .m-select-nav{
        height: 32px;
        text-align: center;
        line-height: 32px;
        color: #8D8F93;
      }
      .m-select-nav1{
        color: #F19E3B;
      }
    }
    .m-tab:nth-child(1){
      width: 100%;
      text-align: center;
    }
    .m-tab:nth-child(2){
      width: 100%;
      text-align: center;
    }
    .m-tab:nth-child(3){
      width: 100%;
      text-align: center;
      color: #2B6CF9;
    }
    .m-height{
      height: 32px;
    }
  }
  .m-btn-next{
    width: 144px;
    margin: 20px  auto 0 auto;
  }
}
</style>

